<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getClaimsHeaders ()"
    :items="getItems ()"
    :loading="loadingClaims"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left"><router-link 
        :to="{name: 'Factoring detail', params: {id: props.item.id}}" 
        target="_self">{{ props.item.id }}</router-link></td>
      <td class="text-xs-left">{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
      <td class="text-xs-left">{{ props.item.Status }}</td>
      <td class="text-xs-left">{{ props.item.Account | account }}</td>
      <td class="text-xs-right">{{ props.item.DueDate | date }}</td>
      <td class="text-xs-right">{{ props.item.FactoringDueDate | date }}</td>
      <td class="text-xs-right">{{ props.item.Capital | amount }}</td>
      <td
        v-if="applicationStatus !== 0"
        class="text-xs-right">{{ props.item.InitialTransferAmount | amount }}</td>
      <td
        v-if="applicationStatus !== 0"
        class="text-xs-right">{{ props.item.FeeAmount | amount }}</td>
      <td
        v-if="applicationStatus !== 0"
        class="text-xs-right">{{ props.item.Buffer | amount }}</td>
      <td
        v-if="applicationStatus === 0"
        class="text-xs-center">-</td>
      <td
        v-if="applicationStatus === 0"
        class="text-xs-center">-</td>
      <td
        v-if="applicationStatus === 0"
        class="text-xs-center">-</td>
      <td
        v-if="applicationStatus === 1 || applicationStatus === 0"
        class="text-xs-right">
        <module-button
          :values="claimsRemoveBtn"
          :loading="processingRemoveClaimFromApplicationRequest"
          :dialog="processingRemoveClaimFromApplicationRequest"
          @confirmClick="$emit('removesFactoringFromApplication',(props.item.id))"/>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
import ModuleButton from '../controllers/ModuleButton.vue';
import EnumIterator from '../helper/EnumIterator';
    export default {
        name: "ApplicationDetailDatagrid",
        components: {ModuleButton,DataGridSort},
        props: ['loadingClaims','claims','applicationStatus','processingRemoveClaimFromApplicationRequest','rowsPerPage'],
        data () {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        computed: {
            claimsRemoveBtn()
            {
                let removeBtn  =
                    {
                        icon:'remove',
                        headline: this.$t('krita.application.removefactoring'),
                        confirmBtnText: this.$t('krita.application.removefactoring'),
                        openBtnText: this.$t('krita.application.modal.remove'),
                        text: this.$t('krita.application.modal.removetext'),
                        openBtnColor:'warning',
                        confirmBtnColor:'warning'
                    };
                return removeBtn;
            },
        },
        methods: {
            getClaimsHeaders ()
            {
                return [
                  {sortable: true, text: this.$t('krita.claims.id'), value: 'Id', align: 'left'},
                  {sortable: true, text: this.$t('krita.claims.namekennitala'), value: 'Debtor', align: 'left'},
                  {sortable: true, text: this.$t('krita.claims.status'), value: 'status', align: 'left'},
                  {sortable: true, text: this.$t('krita.application.claimaccountnumber'), value: 'Account', align: 'left'},
                  {sortable: true, text: this.$t('krita.application.duedate'), value: 'dueDate', align: 'right'},
                  {sortable: true, text: this.$t('krita.application.factoringduedate'), value: 'factoringDueDate', align: 'right'},
                  {sortable: true, text: this.$t('krita.application.capital'), value: 'Amount', align: 'right'},
                  {sortable: true, text: this.$t('krita.application.initialtransferamount'), value: 'InitialTransferAmount', align: 'right'},
                  {sortable: false, text: this.$t('krita.application.feeamount'), value: 'feeAmount', align: 'right'},
                  {sortable: false, text: this.$t('krita.application.buffer'), value: 'buffer', align: 'right'},
                  {sortable: false, text: '', value: 'placeholder', align: 'right'}
                  ]
            },
          getItems ()
          {
            let self = this;

            let claims = [];

            for (let claim of self.claims) {
              let claimClient = {
                id: claim.id,
                Account: claim.Account,
                Capital: claim.Capital,
                Created: claim.Created,
                DebtorName: claim.DebtorName,
                DebtorRegistryId: claim.DebtorRegistryId,
                DueDate: claim.DueDate,
                FactoringDueDate: claim.FactoringDueDate,
                FeeAmount: claim.FeeAmount,
                InitialTransferAmount: claim.InitialTransferAmount,
                LastPaymentDate: claim.LastPaymentDate,
                LeftToPay: claim.LeftToPay,
                Buffer: claim.Buffer,
                Status: self.$t(EnumIterator.processFactoringStatus(claim.Status))
              };
              claims.push(claimClient);
            }
            return claims;
          },
          changeSort (sort)
          {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
          }
        }
    }
</script>

<style scoped>

</style>
